import './DAcDashboard.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import DashboardTable from './components/DashboardTable/DashboardTable';
import { IconNewApp } from './components/icons/newapp';
import { IconMiniWarning } from '../atoms/Icons';
import InjectHTML from '../DAcCreateAccount/components/InjectHTML';
const DAcDashboard = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const {
    fields,
    params
  } = props;
  const {
    data: {
      configuration,
      dictionary,
      settings
    }
  } = fields;
  const newApplicationLink = get(configuration, 'buttonApplicationNewUrl.jss.value.href');
  const [appStatus, setAppStatus] = React.useState({
    available: 0,
    existing: 0
  });
  const applicantsMessage = getDictionaryItem(dictionary, 'applicationsLeftMessage');
  const formatApplicantsMessage = (available, members) => {
    return applicantsMessage.replace('$available$', available).replace('$members$', members);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "dac-dashboard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "dac-dashboard__title"
  }, get(configuration, 'dashboardTitle.jss.value'))), appStatus.available - appStatus.existing > 0 && /*#__PURE__*/React.createElement("div", {
    className: "col-5 col-lg-3 d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("a", {
    href: newApplicationLink,
    className: "btn btn-primary dac-dashboard__start-new ml-md-auto"
  }, /*#__PURE__*/React.createElement(IconNewApp, null), getDictionaryItem(dictionary, 'startANewApplications')))), applicantsMessage && appStatus.available - 1 > 0 && /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info__icon"
  }, /*#__PURE__*/React.createElement(IconMiniWarning, null)), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-info__text"
  }, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: formatApplicantsMessage(`${appStatus.available - appStatus.existing}/${appStatus.available}`, String(appStatus.available - 1))
  }))), /*#__PURE__*/React.createElement(DashboardTable, {
    configuration: configuration,
    dictionary: dictionary,
    settings: settings,
    getAppStatus: setAppStatus
  }), appStatus.available - appStatus.existing > 0 && /*#__PURE__*/React.createElement("a", {
    href: newApplicationLink,
    className: "btn btn-primary dac-dashboard__start-new d-inline-flex d-md-none mt-4"
  }, /*#__PURE__*/React.createElement(IconNewApp, null), getDictionaryItem(dictionary, 'startANewApplications'))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default DAcDashboard;
const commonStyles = "cz9jd1k";
const ltrStyles = "l3g7xa3";
const rtlStyles = "rt5svmu";